// extracted by mini-css-extract-plugin
module.exports = {"studyPlansTable":"StudyPlansList_studyPlansTable__3Fd15","vigente":"StudyPlansList_vigente__90B9d"};